type Standing = {
    win: number;
    lose: number;
    draw: number;
}

export type GamesSummary = {
    official: Standing;
    practice: Standing;
}

export const CLASS_LABEL = {
    regular: 'レギュラー',
    junior: 'ジュニア'
};

export const CLASS_TYPES = ['regular', 'junior'] as const;
export type ClassType = typeof CLASS_TYPES[number];

export type GameScoreboard = {
    id: number;
    date: string;
    event: string;
    opponent: string;
    score: string;
}

type GamesResult = {
    summary: GamesSummary;
    scores: GameScoreboard[];
}

export type TeamGamesResult = {
    [key in ClassType]: GamesResult;
}

export type GamesResults = {
    [year: number]: TeamGamesResult
}

export type GamesState = {
    year: number;
    results: GamesResults;
}

export const INITIAL_STATE: GamesState = {
    year: 2021,
    results: {}
}
